module.exports = __webpack_public_path__ + "assets/1e1343c1982db8bd52a45e10e9cb0fed.mp3";